import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'i18n-js';
import deliveryOptionIcon from 'public/icons/delivery-option.svg';
import _isEmpty from 'lodash/isEmpty';
import cx from 'classnames';
import styles from './styles.less';
import CommonSelector from './common-selector';

const ServiceTypeSectionUI = ({
  onServiceTypeClick,
  selectedServiceTypeKey,
  serviceTypesToRender,
}) => {
  const fetchingService = _isEmpty(serviceTypesToRender);

  if (fetchingService) {
    const serviceTypeFetchingUI = (
      <div className={cx(styles.serviceFetching)}>
        <div className={styles.dot} />
        <div className={styles.sectionFetching}>
          <div className={styles.title} />
          <div className={styles.description} />
        </div>
      </div>
    );
    return (
      <div className={styles.section}>
        <div className={cx(styles.titleFetching)} />
        {serviceTypeFetchingUI}
        {serviceTypeFetchingUI}
      </div>
    );
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>
        {I18n.t('v2.anytimeBooking.serviceTypeSectionTitle')}
      </div>
      <CommonSelector
        options={serviceTypesToRender}
        selectedKey={selectedServiceTypeKey}
        onSelect={onServiceTypeClick}
        defaultOptionIcon={deliveryOptionIcon}
      />
    </div>
  );
};

ServiceTypeSectionUI.defaultProps = {
  selectedServiceTypeKey: undefined,
  serviceTypesToRender: [],
};

ServiceTypeSectionUI.propTypes = {
  onServiceTypeClick: PropTypes.func.isRequired,
  selectedServiceTypeKey: PropTypes.string,
  serviceTypesToRender: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ServiceTypeSectionUI;
